module.exports = __webpack_public_path__ + "static/x86.65a96fd6.png";